/*
	Сохраняем параметры сортировки приложений в localStorage
*/

export const setSortParameters = (sortMethod: string, sortBy: string) => {
	localStorage.setItem("appsSortMethod", sortMethod);
	localStorage.setItem("appsSortBy", sortBy);
};

export const getSortParameters = () => {
	return {
		sortMethod: localStorage.getItem("appsSortMethod"),
		sortBy: localStorage.getItem("appsSortBy"),
	};
};
